import React, { useContext } from 'react'
import BidBidderIcon from '../../../../elements/BidBidderIcon/BidBidderIcon'
import BidWhiteCountdown from '@components/BidCountdown/BidWhiteCountdown'
import { ItemCardManger } from '@components/Cards/BidItem'
import PickupLocation from '@components/Cards/BidItem/shared/PickupLocation'
import BidIncrementButton from '@components/BidIncrementButton'
import BidMsrpButton from '../../../../elements/BidMsrpButton/BidMsrpButton'
import Title from '@components/Cards/BidItem/NotListView/Title'

const Details = ({ loadingBid, setIncrementModalVisible }: any) => {
  const {
    item: {
      lotCode,
      itemClosed,
      quantity,
      soldQuantity,
      bidsEnabled,
      bidsCount,
      msrp,
      utcEndDateTime,
      currentBid,
      pickupLocation,
      itemBidIncrementEnabled,
      removed,
    },
    itemHandler: { openBidHistory },
    location,
  } = useContext<any>(ItemCardManger)
  return (
    <div className="flex items-center">
      <div className="flex items-center">
        <div className="flex-col">
          <Title
            className={'font-bold pr-5 text-sm leading-5 w-44 line-clamp-2'}
          />
          <PickupLocation pickupLocation={location?.nickName} />
        </div>
      </div>
      <div className="w-40">
        <p
          className="block md:mb-1 "
          style={quantity > 1 ? { color: 'red', fontWeight: 'bold' } : {}}
        >
          <span className="font-bold">{itemClosed ? 'SOLD ' : ''}QTY:</span>{' '}
          {itemClosed ? soldQuantity : quantity}
        </p>
        {bidsEnabled && (
          <div className="relative">
            <button
              type="button"
              className={`flex items-center transition duration-300 ease-in-out ${
                loadingBid ? ' opacity-25' : 'opacity-100'
              }`}
              onClick={openBidHistory}
            >
              <BidBidderIcon />
              <span className="text-bidfta-blue-light font-bold block pl-1">
                {bidsCount} BIDDERS
              </span>
            </button>
          </div>
        )}
        <p className={`block my-1 ${!lotCode ? 'invisible' : ''}`}>
          <span className="font-bold">{lotCode}</span>
        </p>
        <div className={`flex gap-1 my-1 ${!msrp ? 'invisible' : ''}`}>
          <span className="font-bold">MSRP:</span> ${msrp?.toFixed(2)}
          <BidMsrpButton lgLeft />
          {itemBidIncrementEnabled && (
            <BidIncrementButton setModalVisible={setIncrementModalVisible} />
          )}
        </div>
        {!itemClosed && !removed && bidsEnabled && (
          <BidWhiteCountdown date={utcEndDateTime} textColor={'text-blue'} />
        )}
        {(currentBid === 0 || currentBid) && bidsEnabled ? (
          <span
            className={`block text-bidfta-blue-light font-bold transition duration-300 ease-in-out ${
              loadingBid ? ' opacity-25' : 'opacity-100'
            }`}
          >
            CURRENT BID: <br />${currentBid.toFixed(2)}
          </span>
        ) : null}
      </div>
    </div>
  )
}

export default Details
